import React from 'react';
import * as Inovx from '@shared';
import OrganizationActions from '../actions/OrganizationActions';
import OrganizationStore from '../stores/OrganizationStore';
import OrganizationAccessRightForm from './OrganizationAccessRightForm';

var SystemActions = Inovx.Shared.System.Actions;
var SystemStore = Inovx.Shared.System.Store;
var InovxControls = Inovx.Shared.Controls;
var UrlUtilities = Inovx.Shared.Common.UrlUtilities;

declare var InovxLoader: any;

const ORGANIZATION_TERMINAL = 'Root';

interface OrganizationProps {
}

interface OrganizationState {
    breadcrumbList: IOrganizationBase[];
    currentList: IOrganizationBase[];
    isEditing: boolean;
}

var _breadcrumbList: IOrganizationBase[] = [];
var _currentLevel: IOrganizationBase = OrganizationStore.getCurrentOrganization();
function getOrganizationState(): OrganizationState {
    return {
        breadcrumbList: _breadcrumbList,
        currentList: OrganizationStore.getCurrentList(),
        isEditing: OrganizationStore.getIsEditing()
    };
}

class OrganizationApp extends Inovx.Shared.ReactExt.BaseAppComponent<OrganizationProps, OrganizationState> {
    constructor(props: OrganizationProps, context: any) {
        super('organization', props, context);

        this.state = getOrganizationState();
    }

    private _onChange = () => {
        this.setState(getOrganizationState());
    }

    protected _initialize = () => {
        _breadcrumbList.push({ Name: InovxLoader.t('organization:breadcrumb.root'), OrganizationType: "Root", ID: '', Description: '', TypeName: '', VersionToken: '', ItemType: 3 });
        _currentLevel = _breadcrumbList[0];

        //Hard coded for now
        OrganizationActions.getAllRoot(5, () => {
            this._appLoaded = true;
        }, (error) => {
            this._handlePermissionError(error);
        },true);
    }

    private _breadcrumbClicked = (organization: IOrganizationBase) => {
        var index = _breadcrumbList.indexOf(organization) + 1;
        _breadcrumbList.splice(index, _breadcrumbList.length - index);

        if (organization.OrganizationType == "Root") {
            //Hard coded for now
            OrganizationActions.getAllRoot(5, () => {
                _currentLevel = organization;
            });
        } else {
            this._getChildren(organization);
        }
    }

    private _itemClicked = (organization: IOrganizationBase) => {
        _breadcrumbList.push(organization);

        this._getChildren(organization);
    }

    private _getChildren(organization: IOrganizationBase) {
        OrganizationActions.getChildren(organization, () => {
                _currentLevel = organization;
            }
        );
    }

    private _editItem = (organization: IOrganizationBase) => {
        OrganizationActions.beginEdit(structuredClone(organization));
    }

    private _endEdit = () => {
        OrganizationActions.endEdit();
    }

    componentWillMount() {
        this.componentWillMountBase();
    }

    componentDidMount() {
        OrganizationStore.addChangeListener(this._onChange);
    }

    componentWillUnmount() {
        OrganizationStore.removeChangeListener(this._onChange);
    }

    public render() {
        var canEdit = true,
            hasChildren = false,
            headerTitle = InovxLoader.t('organization:table.facility');

        if (_currentLevel.OrganizationType !== ORGANIZATION_TERMINAL) {
            //canEdit = false;
            hasChildren = false;
            headerTitle = InovxLoader.t('organization:table.workspace');
        }
        var width = 80;
        var nameWidth = { width: 'calc(100%' + (canEdit ? ' - ' + width + 'px' : '') + ')' };
        var editWidth = { width: width + 'px' };
        var alt = true;
        var children = this.state.currentList.map((item) => {
            alt = !alt;
            var nameProps: any = {
                className: 'tg-cell',
                style: nameWidth
            };
            if (hasChildren) {
                nameProps.onClick = () => { this._itemClicked(item) };
                nameProps.className += ' edit';
            };
            return (
                <div className={`tg-row ${alt ? 'tg-alt' : ''}`} key={item.ID} style={{ width: '100%' }}>
                    <div {...nameProps}>{item.Name}</div>
                    { canEdit
                        ? <div style={editWidth} className='tg-cell'><a className="grid-button" onClick={() => this._editItem(item) }><span className="glyphicon glyphicon-pencil"></span></a></div>
                        : null
                    }
                </div>
            )
        });

        var iconHeaderProps = {
            iconUrl: `${UrlUtilities.getBaseApplicationUrl()}/images/Organization.png`,
            iconAtt: { alt: InovxLoader.t('organization:header.organization') },
            title: InovxLoader.t('organization:header.organization'),
        }

        return (
            <Inovx.Shared.Core.ReactLoader appReady={this.isAppLoaded() } errorStatus={this._errorStatus}>
                <div className="organization-app-content">
                    <Inovx.Shared.Layout.IconHeader {...iconHeaderProps} />
                    <InovxControls.BreadcrumbPanel breadcrumb={this.state.breadcrumbList} onClick={this._breadcrumbClicked} displayProp='Name'>
                        <div className="tg-table">
                            <div className="tg-grid">
                                <div className="tg-header-container">
                                    <div className="tg-header tg-row">
                                        <div className="tg-cell" style={nameWidth}>
                                            <div className="tg-hdr-ctnt">
                                                <div className="tg-title">{headerTitle}</div>
                                            </div>
                                        </div>
                                        { canEdit
                                            ? <div className="tg-cell" style={editWidth}>
                                                <div className="tg-hdr-ctnt">
                                                    <div className="tg-title">{InovxLoader.t('organization:table.action') }</div>
                                                </div>
                                            </div>
                                            : null
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="tg-content-container" style={{ overflow: 'initial'}}>
                                <div className='tg-content'>
                                    {children}
                                </div>
                            </div>
                        </div>
                    </InovxControls.BreadcrumbPanel>
                </div>
                <Inovx.Shared.Controls.ModalSlider isOpen={this.state.isEditing} onClose={this._endEdit}>
                    <OrganizationAccessRightForm />
                </Inovx.Shared.Controls.ModalSlider>
            </Inovx.Shared.Core.ReactLoader>);
    }
}

export default OrganizationApp;
